// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1y2cx","inputDescription":"styles_inputDescription__MniYC"};